import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/content";

export default function WhatsappButton() {
  return (
    <a
      href={BRAND.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[90] flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-xl hover:bg-[#128C7E] transition-colors group"
    >
      <MessageCircle size={22} className="shrink-0" />
      <span className="text-sm font-medium hidden sm:block max-w-0 overflow-hidden group-hover:max-w-[120px] transition-all duration-500 whitespace-nowrap">
        WhatsApp us
      </span>
    </a>
  );
}
